module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Bulb#2-9e8fe6812dde80b3c05334f0039a429d.svg";